// extracted by mini-css-extract-plugin
module.exports = {"custom-metadata-header":"custom-metadata-tree_custom-metadata-header__dz8yW","custom-metadata-title":"custom-metadata-tree_custom-metadata-title__1xYhl"};